import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import {RoutesViewSettingsRoutesModel} from "../../../models/routes-view-settings.model";
import * as _ from "lodash";
import {RoutesComponentStore, VmRoutesComponentState} from "../../state/routes.store";
import {RoutesQueryModel} from "../../../models/routes-query.model";
import {RoutesFacadeService} from "../../../../lean-planning/angular/services/routes-facade.service";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Subscription} from "rxjs";
import {RouteStatusEnum} from "../../../enums/route-status.enum";
import {RouteModel} from "../../../models/route.model";
import {SortType} from "../../../../commons/types/sort.type";
import {RoutePanelModel} from "../../../models/route-panel.model";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {RoutesDragAndDropService} from "../../services/routes-drag-and-drop.service";

require('./routes-panel-list.scss');
@Component({
  standalone: false,
  selector: 'app-routes-panel-list',
  templateUrl: './routes-panel-list.html',
  providers: [RoutesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesPanelListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() settings: RoutesViewSettingsRoutesModel;
  @Input() panel: RoutePanelModel;
  @Input() panels: RoutePanelModel[];
  @Input() resourcesDropListIds: string[];
  @Input() routesDropListIds?: string[];
  @Input() queryString?: string;
  @Input() ids?: string[];
  @Input() from?: string;
  @Input() to?: string;
  @Input() status?: RouteStatusEnum;
  @Input() branchIds?: string[];
  @Input() depotIds?: string[];
  @Input() areaIds?: string[];
  @Input() agentIds?: string[];
  @Input() agentSkills?: string[];
  @Input() resourceIds?: string[];
  @Input() agentScheduleIds?: string[];
  // @Input() statusGroup?: string;
  @Input() tags?: string[];
  @Input() resourceTags?: string[];
  @Input() vehicleTypeIds?: string[];
  @Input() relationTypes?: string[];
  @Input() selectedIds: string[];
  @Input() excludeMode: boolean;
  @Input() visibleIds: string[];
  @Input() sortBy: any;
  @Input() sortType: SortType;
  @Input() selectedServiceIds: string[] = [];
  @Input() expandedRoutes: any[] = [];
  @Output() onToggleSelectRoute = new EventEmitter<{ route: RouteModel, isSelected: boolean }>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onToggleVisible = new EventEmitter<boolean>();
  @Output() onSelectRouteResource = new EventEmitter<any>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onDrillDown = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onEditRoutes = new EventEmitter<any>();
  @Output() onRoutesDropListIdsChange = new EventEmitter<{panel: RoutePanelModel, ids: string[]}>();

  private scrollEndTimer: any | null = null;
  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private viewport: CdkVirtualScrollViewport;


  public vm: VmRoutesComponentState;
  public selectedKeys: Object;
  public visibleKeys: Object;
  public allPanelIds: string[];

  private readonly loadLimit: number = 20;
  private vmSubscription: Subscription;
  private routeMetaDataUpdatedSubscription: Subscription;

  constructor(
    @Inject(RoutesComponentStore) private routesStore: RoutesComponentStore,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(RoutesDragAndDropService) private routesDragAndDropService: RoutesDragAndDropService,
    @Inject(RoutesFacadeService) private routesFacadeService: RoutesFacadeService) {

  }

  onDrop(route: any, event: CdkDragDrop<string[]>) {
    this.routesDragAndDropService.onDropRouteList(
      route,
      event,
      this.selectedServiceIds,
      this.expandedRoutes
    ).then((result) => {
      if (result) {
        this.onEditRoutes.emit(result.data);
      }
    });
  }

  ngOnInit() {
    this.vmSubscription = this.routesStore.vm$.subscribe((vm) => {
      if (!_.isEqual(vm.routes, this.vm?.routes)) {
        const ids = _.map(vm.routes, (r) => {
          return `${this.panel.id}-${r.id}`;
        });
        this.onRoutesDropListIdsChange.emit({panel: this.panel, ids: ids});
      }
      this.vm = {...vm};
      this.viewport?.checkViewportSize();
      this.cdr.detectChanges();
    });

    this.routeMetaDataUpdatedSubscription = this.routesFacadeService.routeMetaDataUpdated$.subscribe((payload) => {
      if (payload?.id && payload?.metaData) {
        this.routesStore.updateRoute({
          id: payload.id,
          metaData: payload.metaData,
          updatedTime: payload.updatedTime,
          updatedAt: payload.updatedAt
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.panels || changes.resourcesDropListIds || changes.routesDropListIds) {
      const drilldownLists = [];
      const filteredPanels = _.filter(this.panels, (p) => {
        if (p.id === this.panel.id) {
          return false;
        }
        drilldownLists.push(`${p.id}-drilldown`);
        return true;
      });
      this.allPanelIds = _.concat(
        _.map(filteredPanels, 'id'),
        this.resourcesDropListIds || [],
        this.routesDropListIds || [],
        drilldownLists
      );
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      });
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
    }
    if (
      changes.queryString ||
      changes.ids ||
      changes.from ||
      changes.to ||
      changes.status ||
      changes.branchIds ||
      changes.depotIds ||
      changes.areaIds ||
      changes.agentIds ||
      changes.agentSkills ||
      changes.resourceIds ||
      changes.agentScheduleIds ||
      changes.tags ||
      changes.resourceTags ||
      changes.vehicleTypeIds ||
      changes.relationTypes ||
      changes.sortBy ||
      changes.sortType
    ) {
      this._resetStore();
      this._getRoutes();
    }
  }

  ngOnDestroy() {
    this.routeMetaDataUpdatedSubscription?.unsubscribe();
    this.vmSubscription?.unsubscribe();
  }

  // getNextBatch() {
  //   if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
  //   this.scrollEndTimer = setTimeout(() => {
  //     if (this.viewport) {
  //       if (this.viewport?.measureScrollOffset('bottom') < 50 && !!this.vm.cursor && !this.vm.loading) {
  //         this._getRoutes();
  //       }
  //       this.viewport.checkViewportSize();
  //     }
  //     this.scrollEndTimer = null;
  //   }, 30);
  // }

  getNextBatch(event: Event) {
    const nextBatchThreshold = this.viewport.getViewportSize();
    if (
      !this.vm?.loading &&
      this.viewport.measureScrollOffset('bottom') < nextBatchThreshold &&
      !!this.vm?.cursor
    ) {
      this._getRoutes();
    }
    this.viewport.checkViewportSize();
  }

  cdkEnterPredicate(): boolean {
    return false;
  }

  onToggleSelectedRoute(route: RouteModel, isSelected: boolean) {
    this.selectedKeys[route.id] = isSelected;
    this.onToggleSelectRoute.emit({route: route, isSelected: isSelected});
  }

  private _resetStore() {
    this.routesStore.resetRoutes();
  }

  private _getRoutes() {
    this.routesStore.getRoutes(this._getRoutesQuery());
  }

  private _getRoutesQuery(): RoutesQueryModel {
    const resourceIds = this.resourceIds || [];
    const agentScheduleIds = this.agentScheduleIds || [];

    const query = {
      ids: this.ids,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: false,
      query: this.queryString,
      from: this.from,
      to: this.to,
      status: this.status,
      branchIds: this.branchIds,
      depotIds: this.depotIds,
      areaIds: this.areaIds,
      agentIds: this.agentIds,
      skill: this.agentSkills,
      allocationIds: resourceIds.concat(agentScheduleIds),
      tags: this.tags,
      resourceTags: this.resourceTags,
      vehicleTypeIds: this.vehicleTypeIds,
      relationTypes: this.relationTypes,
      limit: this.loadLimit,
      sort: (this.sortBy && this.sortType) ? `${this.sortBy},${this.sortType}` : undefined
    }

    Object.keys(query).forEach(key => query[key] === undefined ? delete query[key] : {});
    return query;
  }


  public trackById(_ :number, item: RouteModel): string {
    return item.id;
  }

  protected readonly routeStatusType = RouteStatusEnum;
}
